import dynamic from "next/dynamic";

export const Popover = dynamic(() => import("./component"));
